import { createMuiTheme } from '@material-ui/core/styles'
import { heading } from '../../utils/utils'

const mainFont = 'Gotham' //GOTHAM BOOK medium et bold

const white = '#fff'
const black = '#000'
const primaryMain = '#00233A'
const primaryLight = '#E5E9EB'
const secondaryMain = '#B4D2C1'
const greyLight = '#F7F7F9'
const errorRed = '#EF212B' //Error red	#EF212B
const successGreen = '#59DD92' //Success green	#59DD92
//const messageBlue = '#006CFF' //Message blue	#006CFF
//const warningYellow = '#FFE018' //Warning yellow	#FFE018
const warningOrange = '#FFA70E' //Warning orange	#FFA70E
const checkbox = '#F2F2F2' //Checkbox	#F2F2F2
const buttonDeactive = '#949494' //couleur button désactive

// const imp = '!important'

// const f11 = `11px`
const f12 = `12px`
const f13 = `13px`
const f14 = `14px`
const f15 = `15px`
const f16 = `16px`
const f18 = `18px`

// const f20 = `20px`
// const f22 = `22px`
const f24 = `24px`
const f28 = `28px`
// const f30 = `30px`
const f32 = `32px`

const body = {
  fontSize: f14,
  lineHeight: 1.6,
}
const body2 = {
  fontSize: f13,
  lineHeight: 1.67,
}

const breakPoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
}

const theme = createMuiTheme({
  themeFont: {
    //WARNING FONT NAME WITH SPACE SHOULD HAVE A +. NEXT JS TRIGGER BAD URL FOR GOOGLE FONT
    main: 'Gotham',
  },
  breakpoints: {
    values: breakPoints,
  },
  typography: {
    fontFamily: `${mainFont}, sans-serif`,
    h1: {
      lineHeight: 1.15,
      ...heading(
        '18px !important',
        '28px !important',
        700,
        700,
        mainFont,
        mainFont,
        false
      ),
    },
    h2: {
      lineHeight: 1.15,
      ...heading(f24, f24, 600, 700, mainFont, mainFont, false),
    },
    h3: {
      lineHeight: 1.4,
      ...heading(f18, f18, 700, 700, mainFont, mainFont, false),
    },
    h4: {
      lineHeight: 1.55,
      ...heading(f16, f16, 700, 700, mainFont, mainFont, false),
    },
    h5: {
      lineHeight: 1.25,
      ...heading(f14, f14, 600, 700, mainFont, mainFont, false),
    },
    h6: {
      lineHeight: 1.25,
      ...heading(f12, f12, 600, 700, mainFont, mainFont, false),
    },
    body1: {
      ...body,
    },
    body2: {
      ...body2,
    },
    caption: {
      fontSize: f12,
      lineHeight: 1.17,
      fontWeight: 400,
    },
    button: {
      fontSize: f15,
      lineHeight: 1.67,
      textTransform: 'inherit',
    },
  },
  palette: {
    common: {
      black: primaryMain,
      white: white,
    },
    background: {
      default: white,
      paper: white,
    },
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    success: {
      main: successGreen, //Success green	#59DD92
    },
    error: {
      main: errorRed, //Error red	#EF212B
    },
    warning: {
      main: warningOrange, //Warning orange	#FFA70E
    },
    divider: greyLight,
    primaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    secondaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    ternary: {
      main: '#0082C3',
      light: '#F1FAFF',
    },
    accent: {
      main: '#FFEA28',
    },
  },
  sizes: {
    headerHeight: 60,
    headerHeightTransparent: 90,
    logoWidth: 110,
    logoHeight: 30,
    footerBG: 168,
    basketWidth: 340,
    basketWidthLG: 440,
  },
  extraColors: {
    grey: '#D5D2D9',
    greyLight: '#F5F3F8',
    greyMedium: '#C0BCC6',
    greyText: '#6F677B',
  },
  shadows: [
    'none',
    '0px 0px 15px rgba(46, 46, 46, 0.1)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.react-datepicker__navigation': {
          backgroundColor: `${black}!important`,
        },
        '.react-datepicker__day--in-range, .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected':
          {
            backgroundColor: `${black}!important`,
          },
        '.react-datepicker-popper>div>div>div+div, .react-datepicker__day--today':
          {
            backgroundColor: `${primaryMain}!important`,
            '&>div': {
              color: `${white}!important`,
            },
          },
        '.header--page__nos-partenaires-pour-la-location ~ .page-content #section-text-4 h3':
          {
            marginBottom: '0px !important',
          },
        '.header__lang': {
          '@media (min-width: 768px)': {
            minWidth: '84px !important',
            marginLeft: '1rem !important',
          },
        },
        '.header--page__homepage-location': {
          '& ~ .page-content': {
            '& .hero_content': {
              '& h1': {
                color: `${white} !important`,
              },
            },
            '& h1': {
              letterSpacing: '3px !important',
              '@media (min-width: 1024px)': {
                fontSize: '30px !important',
              },
            },
            '& h2': {
              fontSize: '24px !important',
              fontWeight: '700',
              letterSpacing: '3px !important',
            },
            '& #section-columns-5, & #section-columns-6': {
              '& .page__container--columns': {
                '& .MuiGrid-container': {
                  alignItems: 'center !important',
                },
              },
            },
            '& #section-columns-7': {
              paddingBottom: '60px !important',
              '& .MuiGrid-container': {
                '@media (min-width: 768px)': {
                  alignItems: 'center !important',
                },
              },
              '& .MuiGrid-item>div': {
                textAlign: 'center !important',
              },
            },
            '& p': {
              margin: '0px !important',
            },
            '& #section-columns-2': {
              '& h3, & h4': {
                fontSize: '16px !important',
                margin: '0px !important',
              },
              '& img': {
                margin: '0px !important',
              },
            },
            '& .section-hero_section': {
              minHeight: '220px !important',
            },
          },
        },
        '.shop': {
          '&__planner': {
            '@media (max-width: 480px)': {
              marginTop: '-200px !important',
            },
          },
          '&-menu': {
            '&__right-controls': {
              '&__container': {
                [`@media (max-width: ${breakPoints.md}px)`]: {
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '1rem !important',
                },
              },
            },
            '&__cta': {
              [`@media (max-width: ${breakPoints.md}px)`]: {
                padding: '0px !important',
              },
            },
            '&__sort-input': {
              '&.MuiOutlinedInput-root': {
                borderRadius: '0px !important',
              },
              '&.Mui-focused': {
                border: 'none !important',
              },
            },
          },
        },
        '.header': {
          '&__logo': {
            height: 'auto !important',
            width: '110px !important',
            '@media (min-width: 768px)': {
              width: '190px !important',
            },
          },
          '&__right': {
            width: '40% !important',
          },
          '&__lang': {
            width: '95px !important',
            marginLeft: '28px !important',
          },
        },
        '.footer': {
          '&__logo': {
            width: '100px !important',
            height: '100px !important',
          },
          '&__menu>a': {
            '&:hover': {
              color: `${white} !important`,
              textDecoration: 'underline !important',
            },
          },
          '&__top': {
            backgroundColor: `${white} !important`,
          },
          '&__bottomRow1Col': {
            '@media (max-width: 768px)': {
              display: 'flex',
              flexDirection: 'column',
            },
          },
        },
        // '.hero--shop': {
        //   minHeight: `0 !important`,
        // },
        '.hero__title': {
          '&--second-hand': {
            color: `${white} !important`,
          },
        },
        '.section': {
          '&-faq': {
            '&__cta': {
              '& p': {
                margin: '0px !important',
              },
            },
          },
          '&-infos': {
            '&--no-image': {
              marginTop: '20px !important',
              marginBottom: '20px !important',
            },
            '&__content': {
              [`@media (max-width: ${breakPoints.md}px)`]: {
                textAlign: 'center !important',
              },
            },
          },
          '&-columns': {
            '#section-columns-2': {
              '& .page__container--columns': {
                '& .page-wysiwyg': {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '0 auto',
                  maxWidth: '14.125rem !important',
                  '& > img': {
                    height: '14.125rem !important',
                  },
                },
              },
            },
            '& .page': {
              '&-wysiwyg': {
                '& > img': {
                  marginBottom: '0',
                },
              },
            },
          },
        },
        '.productCard': {
          '&__price': {
            color: `${black} !important`,
          },
        },
        '.pack__prev': {
          color: `${black} !important`,
          borderColor: `${black} !important`,
          '&:hover': {
            borderColor: `${black} !important`,
          },
        },
        '.price__amount': {
          color: `${black} !important`,
        },
        '.funnel': {
          '&__nav': {
            '&--active': {
              color: `${black} !important`,
              borderColor: `${black} !important`,
            },
          },
        },
        '.faq-page__title': {
          color: `${black} !important`,
        },
        '.size-card': {
          '&__quantity-selector': {
            '&--visible': {
              display: 'none',
            },
          },
        },
        '.recapOrder': {
          '&__title > h3': {
            color: `${primaryMain} !important`,
          },
          '&__account_cta': {
            color: `${black} !important`,
            borderColor: ` ${black} !important`,
          },
        },
      },
    },
    MuiButton: {
      root: {
        padding: '12px 45px',
        borderRadius: 0,
      },
      sizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
      sizeLarge: {
        padding: '12px 45px',
      },
      contained: {
        boxShadow: 'none',
        fontSize: '15px !important',
        lineHeight: '17px !important',
        fontWeight: 'bold',
        color: `${white} !important`,
        backgroundColor: `${black} !important`,
        border: `2px solid ${black} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          boxShadow: 'none',
          color: `${black} !important`,
          backgroundColor: `${white} !important`,
        },
      },
      outlined: {
        padding: '12px 45px',
        '&:hover, &:focus, &:active, &.selected': {
          boxShadow: 'none',
          color: `${black} !important`,
          backgroundColor: `${white} !important`,
          borderColor: `${white} !important`,
        },
      },
      outlinedSizeLarge: {
        padding: '12px 45px',
      },
      outlinedSizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
    },
    MuiPaper: {
      root: {
        boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiSelect: {
      root: {
        color: primaryMain,
      },
      selectMenu: {
        '&:focus': {
          background: white,
        },
      },
    },
    MuiChip: {
      root: {
        borderRadius: 0,
        fontSize: 15,
        fontWeight: 700,
        color: black,
        backgroundColor: 'transparent',
        height: 25,
        padding: 0,
      },
      label: {
        padding: 0,
      },
      sizeSmall: {
        height: 22,
        fontSize: 12,
        fontWeight: 400,
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      colorPrimary: {
        color: primaryMain,
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        color: secondaryMain,
        backgroundColor: 'transparent',
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        '&.Mui-checked': {
          color: `${checkbox}`,
        },
      },
      colorSecondary: {
        '&.Mui-checked': {
          color: `${checkbox}`,
        },
      },
    },
  },
})

export default theme
